module.exports = __webpack_public_path__ + "static/sunsmart_promo_high_uv.fe46988a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project6/sunsmart_promo_high_uv.png
// module id = 518
// module chunks = 111663361672460